import type { ComponentPropsWithoutRef } from 'react';
import ValuePickerWrapper from './ValuePickerWrapper';

interface DropdownWithValuePickerProps extends ComponentPropsWithoutRef<typeof ValuePickerWrapper> {
    options: { label: string; value: string }[];
    title: string;
    defaultValue?: string;
}

const DropdownWithValuePicker = ({
    id,
    label,
    isRequired = false,
    testId,
    options,
    value,
    onChangeAsValueReference,
    title,
    container,
    description,
    defaultValue,
}: DropdownWithValuePickerProps) => {
    return (
        <ValuePickerWrapper
            label={label}
            testId={testId}
            container={container}
            description={description}
            isRequired={isRequired}
            id={id}
            onChangeAsValueReference={onChangeAsValueReference}
            value={value}
        >
            <select
                className="form-control"
                id={id}
                value={typeof value === 'string' ? value : defaultValue || ''}
                onChange={({ target: { value } }) => {
                    onChangeAsValueReference(value);
                }}
                title={title}
                required={isRequired}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </ValuePickerWrapper>
    );
};

export default DropdownWithValuePicker;
